module.exports = __webpack_public_path__ + "static/img/302.9d413bff.png";